import { render } from "./Tablet.vue?vue&type=template&id=951926ce"
import script from "./Tablet.vue?vue&type=script&lang=js"
export * from "./Tablet.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Tablet.vue?vue&type=style&index=0&id=951926ce&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__